import { Typography } from "@mui/material";

const requiredField = (show, size = "14px") => {
  return show ? (
    <Typography component="span" color="error.main" style={{ fontSize: size }}>
      *
    </Typography>
  ) : (
    ""
  );
};

export default requiredField;
